class Toast {
  constructor() {
    this.init();
  }
  init() {
    let body = document.body;
    this.$container = document.createElement('div');
    body.appendChild(this.$container);
    this.$container.classList.add('toast-container_simple');
    this.timer = null;
  }
  info(str, dura = 1, cb) {
    // dura d大于100 取毫秒 小于1取秒 * 1000
    this.$container.classList.add('show');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.$container.classList.remove('show');
      this.$container.classList.add('hide');
      this.$container.innerHTML = '';
      cb && cb();
    }, dura * (dura >= 100 ? 1 : dura >= 1 ? 1000 : 1));
    this.$container.innerHTML = str;
  }
  warn(str,dura,cb){
    this.$container.classList.add('show');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.$container.classList.remove('show');
      this.$container.classList.add('hide');
      this.$container.innerHTML = '';
      cb && cb();
    }, dura * (dura >= 100 ? 1 : dura >= 1 ? 1000 : 1));
    this.$container.innerHTML = `<div style="padding: 30px 50px">
                                  <h1 style="text-align: center">
                                    <svg t="1582192269214" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8989" width="32" height="32"><path d="M512 512m-409.6 0a409.6 409.6 0 1 0 819.2 0 409.6 409.6 0 1 0-819.2 0Z" fill="#F44545" p-id="8990"></path><path d="M549.24 700.723v45.76c0 20.545-16.684 37.236-37.235 37.236-20.552 0-37.237-16.69-37.237-37.236v-45.76c0-20.545 16.685-37.236 37.237-37.236 20.55 0 37.236 16.69 37.236 37.236z m-73.974-154.65V276.108c0-20.545 16.674-37.237 37.262-37.237 20.55 0 37.211 16.692 37.211 37.237v269.963c0 20.583-16.66 37.237-37.211 37.237-20.588 0-37.262-16.654-37.262-37.237z" fill="#FFFFFF" p-id="8991"></path></svg>
                                  </h1>
                                  <p>${str}</p>
                                </div>`;
  }
}

export default new Toast();
